import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

export const NumberIcon: FunctionComponent<SvgIconProps> = (props) => (
	<SvgIcon
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			d="M6.66397 18.6667L7.23887 15.7037H4L4.2834 14.2223H7.52227L8.38057 9.77782H5.1417L5.4251 8.29634H8.66397L9.23887 5.33337H10.8583L10.2834 8.29634H15.1417L15.7166 5.33337H17.336L16.7611 8.29634H20L19.7166 9.77782H16.4777L15.6194 14.2223H18.8583L18.5749 15.7037H15.336L14.7611 18.6667H13.1417L13.7166 15.7037H8.8583L8.2834 18.6667H6.66397ZM10 9.77782L9.1417 14.2223H14L14.8583 9.77782H10Z"
			fill="#79818F"
		/>
	</SvgIcon>
);

export default NumberIcon;
